
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/just-water",
      function () {
        return require("private-next-pages/archive/just-water.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/just-water"])
      });
    }
  